import { FiltreEntreeSortie } from "../shared/Enums/listeEntreesSortiesSalarie/filtreEntreeSortie";

export default class formulaireEntreeSortieHelper {

	// Permet de récupérer l'état du formulaire.
    static getEtatDemandeEtat(estSoumise: boolean, estValidee: boolean): FiltreEntreeSortie {
        if (!estSoumise && !estValidee)
            return FiltreEntreeSortie.EnCours;
        else if (estSoumise && !estValidee)
            return FiltreEntreeSortie.AValider;
        else
            return FiltreEntreeSortie.Validees;
    }

    static getEtatDemandeString(EstSoumise: boolean, EstValidee: boolean): string {
        if (!EstSoumise && !EstValidee)
            return "En cours de saisie";
        else if (EstSoumise && !EstValidee)
            return "À valider";
        else
            return "Validée";
    }

    //On peut valider un formulaire si on est Admin PST + état = A valider
    static canValiderWithRole(estSoumise: boolean, estValidee: boolean, isAdminPst: boolean, isAdmin: boolean): boolean {
        let can: boolean = false;
        can = (isAdminPst || isAdmin) && this.canValider(estSoumise, estValidee);

        return can
    }

    //On peut supprimer un formulaire si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    static canSupprimerWithRole(estSoumise: boolean, estValidee: boolean, isAdminPst: boolean, isAdmin: boolean, isUtilisateurPst: boolean): boolean {
        let can: boolean = false;
        let etatDemande: FiltreEntreeSortie = this.getEtatDemandeEtat(estSoumise, estValidee);
        can = ((isAdminPst || isAdmin) && etatDemande == FiltreEntreeSortie.AValider)
            || ((isUtilisateurPst || isAdmin) && etatDemande == FiltreEntreeSortie.EnCours);

        return can
    }

    //On peut soumettre un formulaire si on est utilisateur PST + état = en cours
    static canSoumettreWithRole(estSoumise: boolean, estValidee: boolean, isAdmin: boolean, isUtilisateurPst: boolean): boolean {
        let can: boolean = false;
        can = (isUtilisateurPst || isAdmin) && this.canSoumettre(estSoumise, estValidee);

        return can
    }

    //On peut modifier un formulaire si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    static canModifierWithRole(estSoumise: boolean, estValidee: boolean, isAdminPst: boolean, isAdmin: boolean, isUtilisateurPst: boolean): boolean {
        let can: boolean = false;
        let etatDemande: FiltreEntreeSortie = this.getEtatDemandeEtat(estSoumise, estValidee);
        can = ((isAdminPst || isAdmin) && etatDemande == FiltreEntreeSortie.AValider)
            || ((isUtilisateurPst || isAdmin) && etatDemande == FiltreEntreeSortie.EnCours);

        return can
    }

    //On peut visualiser un formulaire si état = Validees ou si on est utilisateur PST + état = A valider
    static canVisualiserWithRole(estSoumise: boolean, estValidee: boolean, isAdmin: boolean, isUtilisateurPst: boolean): boolean {
        let can: boolean = false;
        let etatDemande: FiltreEntreeSortie = this.getEtatDemandeEtat(estSoumise, estValidee);
        can = (etatDemande == FiltreEntreeSortie.Validees)
            || ((isUtilisateurPst || isAdmin) && etatDemande == FiltreEntreeSortie.AValider);

        return can
    }

    //On peut soumettre un formulaire si état = en cours
    static canSoumettre(estSoumise: boolean, estValidee: boolean): boolean {
        let can: boolean = false;
        let etatDemande: FiltreEntreeSortie = this.getEtatDemandeEtat(estSoumise, estValidee);
        can = etatDemande == FiltreEntreeSortie.EnCours;

        return can
    }

    //On peut valider un formulaire si état = A valider
    static canValider(estSoumise: boolean, estValidee: boolean): boolean {
        let can: boolean = false;
        let etatDemande: FiltreEntreeSortie = this.getEtatDemandeEtat(estSoumise, estValidee);
        can = etatDemande == FiltreEntreeSortie.AValider;

        return can
    }
}



// WEBPACK FOOTER //
// ./src/Helper/formulaireEntreeSortieHelper.ts